import { Task } from "src/store/createJobRotationAssessmentSlice";
import {
  tasksToBeCompletedLabels,
  taskToBeCompletedStatus,
} from "src/jobRotationAssessment/constants/jobRotationConstants";

export const initialTaskToBeCompleted: Task[] = [
  {
    label: tasksToBeCompletedLabels.UPLOAD_VIDEOS,
    status: taskToBeCompletedStatus.STARTED,
  },
  {
    label: tasksToBeCompletedLabels.ADD_WORK_CYCLE_SEGMENTS,
    status: taskToBeCompletedStatus.NOT_STARTED,
  },
  {
    label: tasksToBeCompletedLabels.ADD_MANUAL_ASSESSMENT,
    status: taskToBeCompletedStatus.NOT_STARTED,
  },
];
